<div
  class="icon-circle"
  [ngClass]="'icon-circle--' + variant"
  [style.--icon-circle-size]="size + 'px'"
>
  <icon [set]="set" [name]="name" [size]="resolvedIconSize" />
</div>
